import React from 'react';

import {
	GOOGLE_API_CLIENT_ID,
} from '~/config';



type ButtonConfig = {
	theme?: 'outline' | 'filled_blue' | 'filled_black',
	size?: 'small' | 'medium' | 'large',
	width?: number,
};

type Props = {
	onClick: (values: {
		credential: string,
	}) => void,
	buttonConfig?: ButtonConfig,
	containerClassName?: string,
};

const GoogleSignInButton: React.FC<Props> = (props) => {
	const {
		onClick,
		buttonConfig,
		containerClassName,
	} = props;

	const buttonRef = React.useRef<HTMLDivElement>(null);

	const defaultWidth = buttonConfig?.width ?? 184;

	React.useEffect(
		() => {
			if (!buttonRef.current) {
				return;
			}

			window.google.accounts.id.initialize({
				client_id: GOOGLE_API_CLIENT_ID,
				callback: onClick,
			});

			window.google.accounts.id.renderButton(
				buttonRef.current,
				{
					theme: buttonConfig?.theme ?? 'outline',
					size: buttonConfig?.size ?? 'medium',
					width: defaultWidth,
				},
			);
		},
		[
			onClick,
			buttonConfig?.theme,
			buttonConfig?.size,
			buttonConfig?.width,
			defaultWidth,
		],
	);

	return (
		<div
			className={containerClassName}
			ref={buttonRef}
			style={{
				margin: 'auto',
				width: containerClassName ? '100%' : `${defaultWidth}px`,
			}}
		/>
	);
};



declare global {
	interface Window {
		google: any,
	}
}



export default GoogleSignInButton;
